import SubcategoryPage from '@/components/template/SubcategoryPage';

const Basket = () => {
  const products = [
    {
      title: "Basket Mali",
      imageSrc: "https://images.unsplash.com/photo-1626806787461-102c1a7f1c62?auto=format&fit=crop&q=80",
      url: "/proizvodi/basket-mali"
    },
    {
      title: "Basket Srednji",
      imageSrc: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?auto=format&fit=crop&q=80",
      url: "/proizvodi/basket-srednji"
    },
    {
      title: "Basket Veliki",
      imageSrc: "https://images.unsplash.com/photo-1586198532065-b3a32857c5c4?auto=format&fit=crop&q=80",
      url: "/proizvodi/basket-veliki"
    },
    {
      title: "Basket Luksuzni",
      imageSrc: "https://images.unsplash.com/photo-1523294587484-bae6cc870010?auto=format&fit=crop&q=80",
      url: "/proizvodi/basket-luksuzni"
    },
    {
      title: "Basket Elegantni",
      imageSrc: "https://images.unsplash.com/photo-1557053506-91b1d3b6795c?auto=format&fit=crop&q=80",
      url: "/proizvodi/basket-elegantni"
    },
    {
      title: "Basket Rustikalni",
      imageSrc: "https://images.unsplash.com/photo-1621451067717-c08d5124c256?auto=format&fit=crop&q=80",
      url: "/proizvodi/basket-rustikalni"
    }
  ];

  return (
    <SubcategoryPage
      title="Basket"
      description="Elegantne košare za shranjevanje, ki združujejo funkcionalnost in estetiko za urejen dom."
      heroImage="https://images.unsplash.com/photo-1626806787461-102c1a7f1c62?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Basket;